import { ActionList, Banner, Button, ButtonGroup, DataTable, InlineStack, Pagination, Modal, Popover, Select, Tag, Text, TextField, BlockStack, Card } from '@shopify/polaris';
import React, { useCallback, useEffect, useState } from 'react';
import { Cascader, Pagination as AntPagination, Table } from 'antd';
import { CancelSmallMinor, SaveMinor } from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../Core';
import { syncConnectorInfo, syncNecessaryInfo, syncProfileInfo, syncServices, } from '../../../../Actions/NecessaryFun';
import { trim } from 'lodash';
import ReactJson from 'react-json-view';

interface PropsI extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (
        props: any,
        shop_url?: string | null,
        updateCurrentShop?: boolean,
        updateStepStatus?: React.Dispatch<React.SetStateAction<string>>
    ) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}
let feedResponseViewData: any = {}; //global array to hold feed responses
function Feeds(props: PropsI) {
    const columns = [
        {
            title: "Feed Id",
            dataIndex: "feed_id"
        },
        {
            title: "Status",
            dataIndex: "status"
        },
        {
            title: "Type",
            dataIndex: "type"
        },
        {
            title: "Created at",
            dataIndex: "created_at"
        },
        {
            title: "Executed at",
            dataIndex: "executed_at"
        },
        {
            title: "Feeds",
            dataIndex: "feeds"
        },
        {
            title: "Response",
            dataIndex: "response"
        },
        {
            title: "Specifics",
            dataIndex: "specifics"
        }

    ];
    const specificColumn = [
        {
            title: "IDs",
            dataIndex: "ids"
        },
        {
            title: "Type",
            dataIndex: "type"
        },
        {
            title: "Marketplace",
            dataIndex: "marketplace"
        },
        {
            title: "Shop Id",
            dataIndex: "shop_id"
        },
        {
            title: "Process Type",
            dataIndex: "process_type"
        }
    ]
    const options = [
        {
            value: 'Feed Id',
            label: 'Feed Id',
            children: [
                {
                    value: 'Equals',
                    label: 'Equals',
                },
                {
                    value: 'Contains',
                    label: 'Contains',
                },
            ],
        },
        {
            value: 'Status',
            label: 'Status',
            children: [
                {
                    value: 'Equals',
                    label: 'Equals',
                    children: [
                        {
                            value: 'Submitted',
                            label: 'Submitted',
                        },
                        {
                            value: 'INQUEUED',
                            label: 'INQUEUED',
                        },
                        {
                            value: 'Done',
                            label: 'Done',
                        },
                    ],
                },
            ],
        },
        {
            value: 'Type',
            label: 'Type',
            children: [
                {
                    value: 'Equals',
                    label: 'Equals',
                    children: [
                        {
                            value: 'Product Upload',
                            label: 'Product Upload',
                        },
                        {
                            value: 'Product Inventory',
                            label: 'Product Inventory',
                        },
                        {
                            value: 'Product Price',
                            label: 'Product Price',
                        },
                        {
                            value: 'Product Image',
                            label: 'Product Image',
                        },
                        {
                            value: 'Product Relationship',
                            label: 'Product Relationship',
                        },
                        {
                            value: 'Order Fullfillment',
                            label: 'Order Fullfillment',
                        },
                        {
                            value: 'Product Delete',
                            label: 'Product Delete',
                        },
                        {
                            value: 'JSON Listings Feed',
                            label: 'JSON Listings Feed',
                        },
                        {
                            value: 'JSON Inventory',
                            label: 'JSON Inventory',
                        },
                        {
                            value: 'JSON Image',
                            label: 'JSON Image',
                        },
                        {
                            value: 'JSON Delete',
                            label: 'JSON Delete',
                        },
                        {
                            value: "JSON Price",
                            label: "JSON Price",
                        },
                    ],
                },
            ],
        },
        {
            value: "ids",
            label: "Ids",
            children: [
                {
                    value: 'Equals',
                    label: 'Equals',
                },
                {
                    value: 'Contains',
                    label: 'Contains',
                },
            ],
        }
    ];
    const [feedData, setfeedData] = useState<any>()
    const [totalCount, settotalCount] = useState<any>(25)
    const [data_count, setdata_count] = useState<any>('25')//25
    const [active_page, setactive_page] = useState<any>('1')
    const [activeSyncModal, setactiveSyncModal] = useState(false)
    const [activeDeleteModal, setactiveDeleteModal] = useState(false)
    const [modalData, setmodalData] = useState<any>()
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
    const [rowsData, setrowsData] = useState<any>([])
    const [header, setheader] = useState<any>([])
    const rowSelection: any = {
        selectedRowKeys,
        onChange: (selectedRowKeys: any, selectedRows: any) => {
            setSelectedRowKeys(selectedRowKeys)
        }
    };
    const [filterArray, setfilterArray] = useState<any>(['Feed Id', 'Equals'])
    const [searchInput, setsearchInput] = useState<any>([])
    const [allFilters, setallFilters] = useState<any>({ "Feed Id": ['Feed Id', 'Equals'] })
    const [disableSearchField, setdisableSearchField] = useState(false)
    const sourceData = props.redux?.current?.source;
    const targetData = props.redux?.current?.target;
    const [activeFeedModal, setactiveFeedModal] = useState(false);
    const [activeResponseModal, setactiveResponseModal] = useState(false);
    const [activeSpecificModal, setactiveSpecificModal] = useState(false);
    const [showTag, setshowTag] = useState(false)
    const [loadFeedResponseModal, setloadFeedResponseModal] = useState(false)
    const [loadTable, setloadTable] = useState(false)
    const [filterKey, setfilterKey] = useState("Feed Id");
    const [page, setpage] = useState<any>(1);
    const [pageSize, setpageSize] = useState(50);
    const [totalData, settotalData] = useState(0)

    const onChange = (value: any) => {
        setshowTag(true)
        setfilterArray(value)
        let temp = { ...allFilters };
        temp[value[0]] = value
        setallFilters({ ...temp })
        if (value[0] == 'Feed Id' || value[0] == 'ids') {
            setfilterKey(value[0]);
            setdisableSearchField(false)
        }
        else {
            setdisableSearchField(true)
            setsearchInput('')
        }
    };
    const handleSelectChange = useCallback((value: string) => setdata_count(value), []);
    const option = [
        { label: '25', value: '25' },
        { label: '50', value: '50' },
        { label: '75', value: '75' },
    ];
    const handleChange = useCallback((newValue: string) => setactive_page(newValue), []);
    const tagMarkup = Object.values(allFilters).map((e: any) => {
        let toSet = [];
        (typeof e) == 'object' ? toSet = e : toSet = ['Feed Id', 'Equals']
        return toSet[2] && <Tag
            onRemove={() => {
                delete allFilters[e[0]]
                e[0] == 'Feed Id' ? setsearchInput('') : {}
                let temp = { ...allFilters }
                setallFilters(temp)
                getAllData('removeTag');
            }}>
            {toSet.join(" ")}
        </Tag>
    });

    const getFeedFilters = () => {
        props.di.GET("amazon/request/getFeedTypes").then((e) => {
            if (e.success) {
                if (e.data) {
                    setFilterObject(e.data);
                    const invertedObject: any = {};

                    for (const key in e.data) {
                        if (e.data.hasOwnProperty(key)) {
                            const value = e.data[key];
                            invertedObject[value] = key;
                        }
                    }
                    setDisplayObject(invertedObject);
                }
            } else {
                setFilterObject({
                    'Feed Id': 'feed_id',
                    'Status': 'status',
                    'Type': 'type',
                    'Equals': 1,
                    'Contains': 3,
                    'Submitted': '_SUBMITTED_',
                    'INQUEUED': 'IN_QUEUE',
                    'Done': '_DONE_',
                    'Product Upload': 'POST_FLAT_FILE_LISTINGS_DATA',
                    'Product Inventory': '_POST_INVENTORY_AVAILABILITY_DATA_',
                    'Product Price': '_POST_PRODUCT_PRICING_DATA_',
                    'Product Image': '_POST_PRODUCT_IMAGE_DATA_',
                    'Product Relationship': '_POST_PRODUCT_RELATIONSHIP_DATA_',
                    'Order Fullfillment': '_POST_ORDER_FULFILLMENT_DATA_',
                    'Product Delete': '_POST_PRODUCT_DATA_',
                    'JSON Listings Feed': 'JSON_LISTINGS_FEED',
                    'JSON Inventory': 'JSON_LISTINGS_FEED_INVENTORY',
                    'JSON Image': 'JSON_LISTINGS_FEED_IMAGE',
                    'JSON Delete': 'JSON_LISTINGS_FEED_DELETE'
                });
                setDisplayObject({
                    'feed_id': 'Feed Id',
                    'ids': 'ids',
                    'status': 'Status',
                    'type': 'Type',
                    '_SUBMITTED_': 'Submitted',
                    'IN_QUEUE': 'INQUEUED',
                    '_DONE_': 'Done',
                    'POST_FLAT_FILE_LISTINGS_DATA': 'Product Upload',
                    'JSON_LISTINGS_FEED_UPDATE': 'Product Upload',
                    'POST_INVENTORY_AVAILABILITY_DATA': 'Product Inventory',
                    'POST_PRODUCT_PRICING_DATA': 'Product Price',
                    'POST_PRODUCT_IMAGE_DATA': 'Product Image',
                    'POST_PRODUCT_RELATIONSHIP_DATA': 'Product Relationship',
                    'POST_ORDER_FULFILLMENT_DATA': 'Order Fullfillment',
                    'POST_PRODUCT_DATA': 'Product Delete',
                    'JSON_LISTINGS_FEED': 'JSON Lisitings Feed',
                    'JSON_LISTINGS_FEED_INVENTORY': 'JSON Inventory',
                    'JSON_LISTINGS_FEED_IMAGE': 'JSON Image',
                    'JSON_LISTINGS_FEED_DELETE': 'JSON Delete'
                });
            }
        })
    }
    const [popoverActive, setPopoverActive] = useState(false);
    const togglePopoverActive = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        [],
    );

    const [filterObject, setFilterObject] = useState<any>({});
    const [displayObject, setDisplayObject] = useState<any>({})



    const activator = (
        <ButtonGroup variant="segmented">
            <Button onClick={togglePopoverActive} disclosure>
                {selectedRowKeys.length} selected for:
            </Button>
            <Button icon={CancelSmallMinor} onClick={() => setSelectedRowKeys('')} />
        </ButtonGroup>
    );
    const necessaryDetails: any = {
        'source': {
            'shopId': sourceData?._id, // shopify shop id
            'marketplace': sourceData?.marketplace // shopify
        },
        'target': {
            'shopId': targetData?._id, // amazon shop id
            'marketplace': targetData?.marketplace // amazon
        }
    }

    useEffect(() => {
        getFeedFilters();
    }, [])
    useEffect(() => {
        Object.keys(displayObject).length && getAllData();
    }, [data_count, active_page, displayObject])

    useEffect(() => {
    }, [filterArray])


    // object to handle filter



    function syncFeed() {
        let tempFeedArr: any = []
        let feedArr: any = []
        selectedRowKeys.map((e: any) => {
            feedArr.push(e)
        })
        tempFeedArr['feed_id'] = feedArr
        tempFeedArr = { ...tempFeedArr, ...necessaryDetails }
        props.di.POST("amazon/request/syncFeed", {
            ...tempFeedArr
        }).then((data: any) => {
            if (data.success) {
                props.success(data.message)
            }
            else {
                props.error(data.message)
            }
        })
        setactiveSyncModal(false)
        getAllData()
    }

    function deleteFeed() {
        let tempFeedArr: any = []
        selectedRowKeys.map((e: any) => {
            tempFeedArr.push({ feed_id: e })
        })
        props.di.POST("amazon/request/deleteFeed", {
            feeds: tempFeedArr
        }).then((data: any) => {
            if (data.success) {
                props.success(data.message)
                getAllData()
            }
        })
        setactiveDeleteModal(false)
        getAllData()
    }


    useEffect(() => {
        modalData && settotalData(modalData.length)
        if (modalData && modalData.length > 50) {
            const pages = Math.ceil(modalData.length / pageSize);

            const pageData = modalData.slice((page * pageSize) - pageSize, page * pageSize);
            page === 1 ? setrowsData(pageData) : setrowsData([...header, ...pageData])

            // settotalPages(pages)
        }
        else {
            // settotalPages(1)
            setrowsData(modalData)
        }
    }, [modalData, page])


    function prepareDisplayData(data: any, type: any, field: any) {
        if (field === 'feed_view') {
            let tempData = JSON.parse(data?.data?.request)?.content;
            let displayData: any;
            if (type === 'Product Upload') {
                displayData = tempData.split("\n").map((item: any) => {
                    return item.split("\t") // .filter((x: any) => x !== " " && x !== "")
                })
            } else if (type?.includes('JSON')) {
                displayData = tempData.split("{").filter((x: any) => x !== " " && x !== "").map((it: any) => { return it.split(",") });
            } else {
                displayData = tempData.split(" ").filter((x: any) => x !== " " && x !== "");
                let temp: any = [];
                displayData.map((itm: any) => {
                    temp.push([itm]);
                })
                displayData = temp;
            }
            let header = displayData.slice(0, 3)
            setheader(header)
            setmodalData(displayData)
        } else {
            if (type === 'Product Upload') {
                let tempData = data.data.response.split("\n");
                let displayTempData = tempData.map((item: any) => {
                    return item.split("\t")
                })

                setmodalData(displayTempData)
            } else if (type?.includes('JSON')) {
                let tempData = data.data.response
                let displayTempData: any = [];
                Object.keys(tempData).map((head: any) => {
                    displayTempData.push([head]);
                    head !== 'issues' && displayTempData.push(Object.keys(tempData[head]));
                    head !== 'issues' && displayTempData.push(Object.values(tempData[head]));
                    head === 'issues' && Object.keys(tempData[head]).map((sub: any) => {
                        displayTempData.push(Object.keys(tempData[head][sub]))
                        displayTempData.push(Object.values(tempData[head][sub]))
                    })
                })
                setmodalData(displayTempData)
            } else {
                let tempData = data.data.response.split("\n");
                let displayTempData: any = []
                tempData.map((item: any) => {
                    displayTempData.push([item])
                })
                setmodalData(displayTempData)
            }
        }
        setloadFeedResponseModal(false)
    }

    function getSyncFeedModal() {
        setactiveSyncModal(true)
    }

    function getDeleteFeedModal() {
        setactiveDeleteModal(true)
    }





    function getSpecificsModal(specifics: any) {
        activeSpecificModal == true ? setactiveSpecificModal(false) : setactiveSpecificModal(true)
        let tempObj: any = []
        tempObj.push({
            ids: specifics.ids.join('\r\n'),
            type: displayObject[specifics.type],
            marketplace: specifics.marketplace,
            shop_id: specifics.shop_id,
            process_type: specifics?.process_type ?? "N/A"
        })
        setmodalData(tempObj)
    }

    function handleSearchInput(e: any) {
        setshowTag(true)
        let tempAllFilters: any = { ...allFilters }
        e != '' ? tempAllFilters[filterKey][2] = e : ''
        setallFilters({ ...tempAllFilters })
        setsearchInput(e)
    }

    function resetFilter() {
        setdisableSearchField(false)
        setdata_count('25')
        setactive_page('1')
        let temp = ['Feed Id', 'Equals'];
        setfilterArray(temp)
        setallFilters({ "Feed Id": temp });
        setsearchInput('')
        getAllData('reset')

    }
    function getAllData(reset?: string) {
        let params: any = {}
        let filter: any = {};
        setloadTable(true)
        let tempObj: any = []
        let obj: any = {};
        reset != 'reset' && Object.keys(allFilters).map((e: any) => {
            let temp: any = [];
            allFilters[e] && allFilters[e].forEach((e1: any) => {
                temp.push(filterObject[e1] ? filterObject[e1] : e1)
            })
            let str1 = '';
            let str2 = '';
            params['filter'] = {}
            if (!(temp[0] == "feed_id" && temp[2] == undefined)) {
                let tempFilter = { ...filter };
                tempFilter = { ...tempFilter, [temp[0]]: { [temp[1]]: temp[2] } }
                filter = tempFilter;
                params = { ...params, filter: filter }
            }
        })

        // object to handle data display
        params['data'] = {
            'activePage': active_page,
            'count': data_count,
        }
        params = { ...params, ...necessaryDetails }
        props.di.POST("amazon/request/getAllFeeds", params).then((data: any) => {
            if (data.success) {
                data.data.rows.map((e: any) => {
                    feedResponseViewData = { ...feedResponseViewData, [e.feed_id]: { 'feed_view': false, "response_view": false } }
                    tempObj.push({
                        key: e.feed_id,
                        feed_id: e.feed_id,
                        status: displayObject[e.status],
                        type: displayObject[trim(e.type, "_")],
                        created_at: e.feed_created_date,
                        executed_at: e.feed_executed_date,
                        // feeds: <Button icon={downloadButton?.feed_view ? SaveMinor : undefined} onClick={() => { getFeedViewModal(e, 'feed_view', displayObject[e.type]) }}>View</Button>,
                        feeds: <FeedViewButtons
                            setactiveResponseModal={setactiveResponseModal}
                            setmodalData={setmodalData}
                            data={e}
                            type={"feed_view"}
                            prepareDisplayData={prepareDisplayData}
                            props={props}
                            setloadFeedResponseModal={setloadFeedResponseModal}
                            setactiveFeedModal={setactiveFeedModal}
                            displayObject={displayObject}
                            activeFeedModal={activeFeedModal} />,
                        response: <FeedViewButtons
                            setactiveResponseModal={setactiveResponseModal}
                            setmodalData={setmodalData}
                            data={e}
                            type={"response_view"}
                            prepareDisplayData={prepareDisplayData}
                            props={props}
                            setloadFeedResponseModal={setloadFeedResponseModal}
                            setactiveFeedModal={setactiveFeedModal}
                            displayObject={displayObject}
                            activeFeedModal={activeFeedModal} />,
                        // response: <Button onClick={() => { getResponseViewModal(e, 'response_view', displayObject[e.type]) }}>View</Button>,
                        specifics: <Button onClick={() => { getSpecificsModal(e.specifics) }}>View</Button>
                    })
                })
                settotalCount(data.data.count)
            }
            setfeedData(tempObj)
            setloadTable(false)
        })
    }

    return (
        <div className='card-box-shadow'>
            <Card roundedAbove='sm'>
                {(Object.keys(displayObject).length && Object.keys(filterObject).length) ?
                    <BlockStack>
                        <InlineStack align='space-between'>
                            <InlineStack blockAlign='center'>
                                <Cascader options={options} onChange={onChange} value={filterArray} allowClear={false} />
                                <TextField label="" disabled={disableSearchField} placeholder="Enter required Id." value={searchInput} onChange={(e) => { handleSearchInput(e) }} autoComplete="off" />
                                <ButtonGroup variant='segmented'>
                                    <Button onClick={getAllData}>Apply Filters</Button>
                                    <Button onClick={resetFilter}>Reset</Button>
                                </ButtonGroup>
                            </InlineStack>
                            <InlineStack blockAlign='center'>
                                {
                                    selectedRowKeys.length > 0 &&
                                    <Popover
                                        active={popoverActive}
                                        activator={activator}
                                        autofocusTarget="first-node"
                                        onClose={togglePopoverActive}
                                    >
                                        <ActionList
                                            actionRole="menuitem"
                                            items={[
                                                { content: 'Sync', onAction: getSyncFeedModal },
                                                { content: 'Delete', onAction: getDeleteFeedModal }
                                            ]}
                                        />
                                    </Popover>
                                }
                                <Select
                                    label=""
                                    options={option}
                                    onChange={handleSelectChange}
                                    value={data_count}
                                />
                                <Pagination
                                    label={<><InlineStack blockAlign='center'>
                                        <div style={{ maxWidth: '50px' }}>
                                            <TextField
                                                label=""
                                                value={active_page + ''}
                                                onChange={handleChange}
                                                autoComplete="off"
                                                align="center"
                                                disabled={true}
                                            />
                                        </div>
                                        <Text as='p' tone='subdued'>/ {Math.ceil(totalCount / data_count) ? Math.ceil(totalCount / data_count) : 1} pages</Text>
                                    </InlineStack></>}
                                    hasPrevious={active_page > 1 ? true : false}
                                    onPrevious={() => {
                                        if (active_page > 1) {
                                            setactive_page(parseInt(active_page) - 1)
                                        }
                                    }}
                                    hasNext={!(active_page >= Math.ceil(totalCount / data_count))}
                                    onNext={() => {
                                        if (active_page > 0 && active_page < Math.ceil(totalCount / data_count)) {
                                            setactive_page(parseInt(active_page) + 1)
                                        }
                                    }}
                                />
                            </InlineStack>
                        </InlineStack>
                        {
                            showTag &&
                            <InlineStack gap="2000">{tagMarkup}</InlineStack>
                        }
                        <Table
                            loading={loadTable}
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={feedData}
                            pagination={false}
                            scroll={{
                                x: 1300,
                            }}
                        />
                    </BlockStack> : <></>}
            </Card>

            <Modal
                open={activeSyncModal}
                onClose={() => setactiveSyncModal(false)}
                title="Action permission required"
                primaryAction={
                    {
                        content: "Proceed",
                        onAction: syncFeed,
                    }
                }
            >
                <Modal.Section>
                    <BlockStack gap="200">
                        <Text as='p'>
                            Do you want to sync feed(s) ?
                        </Text>
                    </BlockStack>
                </Modal.Section>
            </Modal>

            <Modal
                open={activeDeleteModal}
                onClose={() => setactiveDeleteModal(false)}
                title="Action permission required"
                primaryAction={
                    {
                        content: "Proceed",
                        onAction: deleteFeed,
                    }
                }
            >
                <Modal.Section>
                    <BlockStack gap="200">
                        <Text as='p'>
                            Do you want to delete feed(s) ?
                        </Text>
                    </BlockStack>
                </Modal.Section>
            </Modal>

            <Modal
                open={activeFeedModal}
                loading={loadFeedResponseModal}
                onClose={() => { setactiveFeedModal(false); setmodalData(""); setloadFeedResponseModal(false) }}
                title="Feed"
                size="large"
            >
                <Modal.Section>
                    {modalData && modalData?.length > 0 ? rowsData && <MddaldataView setpage={setpage} totalPages={totalData} setpageSize={setpageSize} pageSize={pageSize} rowsData={rowsData}></MddaldataView> : modalData}
                </Modal.Section>
            </Modal>

            <Modal
                open={activeResponseModal}
                loading={loadFeedResponseModal}
                onClose={() => { setactiveResponseModal(false); setmodalData(""); setloadFeedResponseModal(false) }}
                title="Response"
                size="large"
            >
                <Modal.Section>
                    {
                        typeof modalData == "object" ? <div className='feedSectionModal'><DataTable columnContentTypes={['text']} headings={[]} rows={modalData} /></div> : modalData
                    }
                </Modal.Section>
            </Modal>

            <Modal
                open={activeSpecificModal}
                onClose={() => { setactiveSpecificModal(false); setmodalData("") }}
                title="Specifics"
            >
                <Modal.Section>
                    <BlockStack gap="200">
                        <Table
                            columns={specificColumn}
                            dataSource={modalData}
                            pagination={false}
                        />
                    </BlockStack>
                </Modal.Section>
            </Modal>
        </div>
    );
}
export default DI(Feeds, {
    func: {
        syncNecessaryInfo,
        syncConnectorInfo,
        syncProfileInfo,
        syncServices,
    },
});

function MddaldataView({ rowsData, pageSize, setpage, setpageSize, totalPages }: any) {
    const onchangePagination = (page: number, pageSize: number) => {
        setpage(page);
        setpageSize(pageSize)
    }
    return (
        <div className='feedSectionModal'>
            <BlockStack align="end">
                <AntPagination
                    total={totalPages}
                    simple
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                    pageSize={pageSize}
                    defaultCurrent={1}
                    onChange={onchangePagination}

                ></AntPagination>
                <DataTable columnContentTypes={['text']} headings={[]} rows={rowsData}
                />
            </BlockStack>
        </div>

    )
}



function FeedViewButtons({ setloadFeedResponseModal, setactiveResponseModal, props, prepareDisplayData, setactiveFeedModal, activeFeedModal, data, type, displayObject, setmodalData }: any) {
    const [downloadButton, setdownloadButton] = useState({
        feed_view: false,
        response: false
    })
    const [View, setView] = useState("View")
    const [downloadFile, setdownloadFile] = useState(false)
    const [URL, setURL] = useState<string>('')
    const [dataTotal, setdataTotal] = useState<any>([])
    const [loading, setloading] = useState(false);
    // function convertToJson(data: any) {
    //     let unescapedJsonString = data.replace(/\\"/g, '"');
    //     unescapedJsonString = unescapedJsonString.replace(/"{/g, '{').replace(/}"/g, '}');
    //     let jsonObject = JSON.parse(unescapedJsonString);
    //     return jsonObject
    // }

    function convertToJson(data: any): any {
        if (typeof data === "string") {
            try {
                const parsed = JSON.parse(data);
                return convertToJson(parsed); // Recursively parse nested JSON strings
            } catch (e) {
                return data; // Return as is if parsing fails (to avoid breaking)
            }
        } else if (typeof data === "object" && data !== null) {
            for (const key in data) {
                data[key] = convertToJson(data[key]); // Recursively parse all object values
            }
        }
        return data;
    }






    function convertToJsonSample(data1: any) {

        data = data1.request;
        let unescapedJsonString = data.replace(/\\"/g, '"');
        unescapedJsonString = unescapedJsonString.replace(/"{/g, '{').replace(/}"/g, '}');
        let jsonObject = JSON.parse(unescapedJsonString);
        return { ...jsonObject, actionData: data1?.['actionData'], identifiers: data1?.['identifiers'] };
    }
    function getBucketData(feedId: any, field: any, type: any) {
        props.di.POST("amazon/request/getBucketData", { key: feedId }).then((data: any) => {
            setloading(false);
            if (data.success) {
                prepareDisplayData(data, type, field)
            }
        })
    }






    const Test = ({ data, direct }: any) => {
        const [searchQuery, setSearchQuery] = useState('');
        const [filteredData, setFilteredData] = useState({});
        const [flag, setflag] = useState(false)


        if (!direct) {

            let request = convertToJson(data?.request);
            data = { ...data, request: request }
        }

        const handleSearch = () => {
            // Make sure the input is a valid number
            if (searchQuery) {
                const searchId = parseInt(searchQuery, 10);
                if (isNaN(searchId)) {
                    alert('Please enter a valid number for messageId');
                    return;
                }
                // Filter the data based on messageId
                const filtered = data?.request?.content?.messages?.filter((doc: any) => doc.messageId === searchId);
                setFilteredData({ ...data, request: filtered });
                setflag(true)
            }

        };
        const handleKeyPress = (event: React.KeyboardEvent<HTMLSpanElement>) => {
            if (event.key === 'Enter') {
                handleSearch()
            }
        };
        return <BlockStack gap={'500'}>
            {/* Fixed container */}
            {!direct && (
                <div
                    style={{
                        position: 'sticky',
                        top: 0,
                        background: 'white',
                        zIndex: 1000,
                        padding: '16px 0',
                        borderBottom: '1px solid #dfe3e8',
                    }}
                >
                    <BlockStack gap={'300'}>

                        <span onKeyDown={handleKeyPress}>
                            <TextField
                                selectTextOnFocus
                                autoComplete="off"
                                label={undefined}
                                type="number"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e)}
                                placeholder="Enter messageId (e.g., 2)"
                            />
                        </span>
                        <InlineStack gap="200">
                            <Button onClick={handleSearch}>Filter</Button>
                            {Object.keys(filteredData).length > 0 && (
                                <Button
                                    onClick={() => {
                                        setFilteredData({});
                                        setSearchQuery('');
                                    }}
                                >
                                    Reset Filter
                                </Button>
                            )}
                        </InlineStack>

                    </BlockStack>
                </div>
            )}

            {Object.keys(filteredData).length > 0 ?
                <ReactJson displayDataTypes={false} src={filteredData} theme={"monokai"} /> : <ReactJson displayDataTypes={false} src={data} theme={"monokai"} />
            }
        </BlockStack>
    }

    function getFeedResponseView(feedId: any, field: any, type: any, data: any) {

        const necessaryDetails: any = {
            'source': {
                'shopId': props?.redux?.current?.source?._id, // shopify shop id
                'marketplace': props?.redux?.current?.source?.marketplace // shopify
            },
            'target': {
                'shopId': props?.redux?.current?.target?._id, // amazon shop id
                'marketplace': props?.redux?.current?.target?.marketplace // amazon
            },

        }
        let tempData: any = {};
        tempData['key'] = (field == "response_view" ? data?.s3_response_id : data?.s3_feed_id);
        tempData['bucket'] = data?.bucket
        necessaryDetails['data'] = tempData;
        try {
            if (!feedResponseViewData?.[feedId]?.[field]) {
                props.di.POST("amazon/request/feedResponseView", necessaryDetails).then((data: any) => {
                    setloading(false);
                    if (data.success) {
                        if (data?.url) {
                            setdownloadButton({ ...downloadButton, feed_view: true });
                            setView("Download")
                            setdownloadFile(true)
                            setURL(data?.url)
                            setdataTotal(data?.data);
                            props.success("File size is large to view,but you can download the file to view locally")

                        } else {
                            setactiveFeedModal(!activeFeedModal)

                            try {
                                if ((data?.data?.ids && data?.data?.ids?.length > 0 && typeof data?.data?.request == "string")
                                    || (Object?.keys(data?.data?.response?.header ?? {})?.length > 0)
                                ) {
                                    if (data?.data?.ids && data?.data?.ids?.length > 0 && typeof data?.data?.request == "string") {
                                        // setmodalData(<ShopifyDataTable jsonData={JSON.parse(data?.data?.request)}></ShopifyDataTable>)
                                        setmodalData(<Test data={data?.data}></Test>

                                        )

                                    }
                                    else if (Object?.keys(data?.data?.response?.header ?? {})?.length > 0) {
                                        setmodalData(
                                            <Test data={data?.data?.response} direct={true}></Test>
                                        )
                                    }
                                    else {

                                        let temp = { ...feedResponseViewData };
                                        temp[feedId][field] = data;
                                        feedResponseViewData = temp
                                        prepareDisplayData(data, type, field)
                                    }
                                    setloadFeedResponseModal(false)
                                }
                                else if (
                                    JSON.parse(JSON.parse(data?.data?.request)?.content)?.feedType?.includes('JSON')
                                ) {

                                    setmodalData(
                                        <Test data={data?.data}></Test>
                                    )

                                    //  setmodalData(<ShopifyDataTable jsonData={JSON.parse(data?.data?.request)}></ShopifyDataTable>)
                                    setloadFeedResponseModal(false)
                                }
                                else {

                                    let temp = { ...feedResponseViewData };

                                    temp[feedId][field] = data;
                                    feedResponseViewData = temp
                                    prepareDisplayData(data, type, field)
                                }
                            }
                            catch {
                                let temp = { ...feedResponseViewData };

                                temp[feedId][field] = data;
                                feedResponseViewData = temp
                                prepareDisplayData(data, type, field)
                            }
                        }
                    } else {
                        props.error(data.message);
                        setactiveFeedModal(false); setmodalData(""); setloadFeedResponseModal(false);
                        setactiveResponseModal(false); setmodalData(""); setloadFeedResponseModal(false);
                    }
                })
            }
            else {
                setactiveFeedModal(!activeFeedModal)
                prepareDisplayData(feedResponseViewData?.[feedId]?.[field], type, field);
            }
        }
        catch {
            let temp = { ...feedResponseViewData };
            temp[feedId][field] = data;
            feedResponseViewData = temp
            prepareDisplayData(data, type, field)
        }
    }
    function getFeedViewModal(e: any, field: any, type: any) {
        setloading(true);
        setloadFeedResponseModal(true)
        if (e.serverless) {
            getBucketData(e.s3_feed_id, field, type)
        }
        else if (downloadFile) {
            // const pageSize = 25;
            // const page = 1;
            // const pages = Math.ceil(dataTotal.length / pageSize);
            // const pageData = dataTotal.slice((page * pageSize) - pageSize, page * pageSize);
            const link = document.createElement('a');
            link.href = URL;
            // link.download = 'feedview.json'; // Specify the desired file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setloading(false)
        }
        else {
            getFeedResponseView(e.feed_id, field, type, e)
        }
    }
    return (
        <Button loading={loading} icon={downloadButton?.feed_view ? SaveMinor : undefined} onClick={() => { getFeedViewModal(data, type, displayObject[data.type]) }}>{View}</Button>
    )
}

interface Attribute {
    size: string;
    color: string;
    [key: string]: any;
}

interface ProductData {
    id: string;
    title: string;
    price: number;
    attributes: Attribute;
    [key: string]: any;
}

interface ItemAttribute {
    value: string;
    marketplace_id: string;
    language_tag: string;
}

interface Schedule {
    value_with_tax: number;
}

interface OurPrice {
    schedule: Schedule[];
}

interface PurchasableOffer {
    our_price: OurPrice[];
    currency: string;
    marketplace_id: string;
}

interface Attributes {
    item_name: ItemAttribute[];
    purchasable_offer: PurchasableOffer[];
}

type FlatObject = { [key: string]: any };




const ShopifyDataTable = ({ jsonData }: any) => {

    jsonData = JSON.parse(jsonData.content)?.['messages'];

    // Enhanced function to flatten `purchasable_offer`
    function flattenJson(data: any, prefix: string = ''): FlatObject {
        const result: FlatObject = {};

        for (const key in data) {
            const value = data[key];

            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    if (typeof item === 'object' && item !== null) {
                        Object.assign(result, flattenJson(item, `${prefix}/${key}/`));
                    } else {
                        result[`${prefix}/${key}/`] = item;
                    }
                });
            } else if (typeof value === 'object' && value !== null) {
                Object.assign(result, flattenJson(value, `${prefix}${key}_`));
            } else {
                result[`${prefix}${key}`] = value;
            }
        }

        return result;
    }
    jsonData = jsonData.map((item: any) => flattenJson(item));
    // Step 1: Extract unique keys for columns
    const flattenedData = jsonData.map((item: any) => flattenJson(item));

    // Extract unique column headings
    const keys: any = Array.from(new Set(flattenedData.flatMap((item: any) => Object.keys(item))));
    const rows: any = flattenedData.map((item: any) => keys.map((key: any) => item[key]));

    // Define columns for DataTable
    const columns = keys.map((key: any) => ({
        id: key,
        title: key.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').trim(), // Format column title
    }));

    return (
        <DataTable
            columnContentTypes={columns.map(() => 'text')}
            headings={columns.map((col: any) => col.title)}
            rows={rows}
            footerContent={`Showing ${rows.length} entries`}
        />
    );
};







